export default __webpack_public_path__ + "static/media/img_jarvis-colorBkg.943c3061.png";